import requestMaker from 'lib';

export const fetchCaseDetails = ({ caseId }) => {
  const baseQuery = `/proxy/prv/lls/fcd`;
  const params = { caseId };
  const payload = {};
  return requestMaker(baseQuery, { params, payload });
};

export const fetchAssessmentReport = ({ caseId, cobrand = '' }) => {
  const baseQuery = `/proxy/prv/lls/far`;
  const params = { caseId, cobrand };
  const payload = {};
  return requestMaker(baseQuery, { params, payload });
};

export const getAssessmentDetails = data => {
  const baseQuery = `/proxy/prv/lls/gad`;
  const { caseId = '', channel = '', version = '' } = data;
  const params = { caseId, channel, version };
  const payload = {};
  return requestMaker(baseQuery, { payload, params });
};

export const getAssessmentList = profileId => {
  const baseQuery = `/proxy/prv/lls/gal`;
  const params = { source: 'website', profileId };
  const payload = {};
  return requestMaker(baseQuery, { payload, params });
};

export const getAssessmentReport = data => {
  const baseQuery = `/proxy/prv/lls/gar`;
  const { caseId = '' } = data;
  const params = { caseId };
  const payload = {};
  return requestMaker(baseQuery, { payload, params });
};

export const sendAssessmentCommunication = data => {
  const baseQuery = `/proxy/prv/lls/sac`;
  const { caseId = '', OTP, phone, type } = data;
  const params = { caseId };
  const payload = { OTP, phone, type };
  return requestMaker(baseQuery, { payload, params });
};

export const viewAssessmentReports = data => {
  const baseQuery = `/proxy/pbl/lls/var`;
  const { tinyUrlCode = '' } = data;
  const params = { tinyUrlCode };
  const payload = {};
  return requestMaker(baseQuery, { payload, params });
};

export const linkGuestUser = ({ caseId, uId }) => {
  const baseQuery = '/proxy/prv/lls/lgu';
  const params = { caseId };
  const payload = { uid: uId };
  return requestMaker(baseQuery, { params, payload });
};

export const getAssessmentInfo = ({ caseId }) => {
  const baseQuery = '/proxy/prv/lls/gai';
  const params = { caseId };
  const payload = {};
  return requestMaker(baseQuery, { params, payload });
};

export const updateSelfCheckReport = ({ caseId, isActive }) => {
  const baseQuery = '/proxy/prv/lls/usr';
  const params = { caseId };
  const payload = { isActive };
  return requestMaker(baseQuery, { params, payload });
};
